import React , { useState, useEffect} from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import * as Icon from 'react-bootstrap-icons';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import product from './product.json';

export default function Shop() {
    /* Button function */
    let [reset1, setReset1] = useState(false);
    let [reset2, setReset2] = useState(false);
    let [reset3, setReset3] = useState(false);

    /* Product.json */
    const [items, setItems] = useState([]);

    // Fetching product product from json file
    useEffect(() => {
        setItems(product);
    }, []);

    return (
    <>
    <div className='container small-device'>
        <p className='d-flex justify-content-center brand-color fw-bold fs-4 py-4'>Shop</p>
        <InputGroup className='mb-5 search-box'>
            <InputGroup.Text><Icon.Search color='brand-color'/></InputGroup.Text>
            <Form.Control />
        </InputGroup>

        <Row className='pb-3'>
            <Col sm={3}>
                <p className='fw-bold fs-5'>
                    Filter{' '}
                    <span>
                        <button
                            onClick={e => {setReset1(e.target.checked); setReset2(e.target.checked); setReset3(e.target.checked)}}
                            className='font-italic text-secondary fw-normal fs-6 text-decoration-underline clear-button'
                        >
                            Clear
                        </button>
                    </span>
                </p>
                <p>Categories</p>

                <Form>
                    {['checkbox'].map((type) => (
                        <div key={`inline-${type}`} className='mb-3'>
                            <Form.Check checked={reset1} onChange={e => setReset1(e.target.checked)} label='Bread' name='bread' type={type} id={`${type}1`} />
                            <Form.Check checked={reset2} onChange={e => setReset2(e.target.checked)} label='Cake' name='cake' type={type} id={`${type}2`} />
                            <Form.Check checked={reset3} onChange={e => setReset3(e.target.checked)} label='Drinks' name='drinks' type={type} id={`${type}3`} />
                        </div>
                    ))}
                </Form>
            </Col>
            <Col sm={9}>
                <Row>
                    {items.map((item) => (
                    <Col key={item.id} className='mb-4'>
                        <a href={`/${item.page}`} className='profile-link'>
                        <div className='card'>
                            <div className='card-body'>
                                <img src={item.image} className='shop' alt='shop1'></img>
                                <div className='card-text text-center shop-details'>
                                    <p className='shop-margin'>{item.productName}</p>
                                    <p>RM {item.price}</p>
                                </div>
                            </div>
                        </div>
                        </a>
                    </Col>
                    ))}
                </Row>
                <div className='py-4 d-grid gap-2 d-md-flex justify-content-md-center'>
            <button type='button' className='btn login'>Load more</button>
        </div> 
            </Col>           
        </Row>         
    </div>
    </>
  );
}